import { getFirstWeekLoss } from "../helpers"

export default (getView) =>
  ({ nextStepPath }) => ({
    ...getView({
      nextStepPath,
    }),

    init() {
      this.handleLoadingEnd = this.handleLoadingEnd.bind(this)
      this.commonInit()
    },

    getFirstWeekLoss() {
      return getFirstWeekLoss({
        values: this.store.values,
        isMetric: this.store.isMetric()
      })
    },

    handleLoadingEnd() {
      setTimeout(() => {
        window.location = nextStepPath
      }, 2000)
    },
  })
